import { render, staticRenderFns } from "./WXCW03BJRecord.vue?vue&type=template&id=5d7a16cd&scoped=true&"
import script from "./WXCW03BJRecord.vue?vue&type=script&lang=js&"
export * from "./WXCW03BJRecord.vue?vue&type=script&lang=js&"
import style0 from "./WXCW03BJRecord.vue?vue&type=style&index=0&id=5d7a16cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7a16cd",
  null
  
)

export default component.exports